import React from "react";
import { Col, Row } from "react-bootstrap";
import { images } from "../../../constants";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import BackArrow from "../../backArrow";
import { useRef, useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { currencies } from "../../../constants/jsonConstant";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { useGetWorldCitiesQuery } from "../../../features/api/worldCitiesApiSlice";
import { Measurementunit } from "../../../constants/jsonConstant";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { salepromotion } from "../../../constants/jsonConstant";
import { saleoffer } from "../../../constants/jsonConstant";
import { getAsset } from "../../../helpers/helper";

/** Encode category option values so names with "&" (e.g. Gems&jewelry) are not
 *  truncated by HTML attribute parsing. Parent Handledata still receives id.name. */
const categoryOptionValue = (item) =>
  `${item?._id || ""}.${encodeURIComponent(item?.name || "")}`;

const decodeCategorySelectValue = (raw) => {
  const text = String(raw || "");
  const dot = text.indexOf(".");
  if (dot === -1) return text;
  const id = text.slice(0, dot);
  let name = text.slice(dot + 1);
  try {
    name = decodeURIComponent(name);
  } catch (_) {
    /* keep raw */
  }
  return `${id}.${name}`;
};

const PostAddForm = ({
  handlerFunction,
  setUserData,
  userData,
  back,
  cancel,
  id,
  butn,
  Updatehandler,
  index,
  updateurl,
  backurl,
  shopCategorytwo,
  shopCategory,
  Handledata,
  data,
  Mydata,
  getInputProps,
  getRootProps,
  displayimg,
  setDisplayimg,
  FirstCategory,
  isUploading,
  uploadProgress,
}) => {
  const location = useLocation();

  const onCategoryFieldChange = (e, formikHandleChange) => {
    const decoded = decodeCategorySelectValue(e?.target?.value);
    if (typeof Handledata === "function") {
      Handledata({
        ...e,
        target: {
          ...e.target,
          name: e.target.name,
          value: decoded,
        },
      });
    }
    if (typeof formikHandleChange === "function") {
      formikHandleChange(e);
    }
  };
  const [selectedCountry, setSelectedCountry] = useState(
    userData?.country || "",
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedstateone, setSelectedstateone] = useState(
    userData?.state || "",
  );
  const [searchTermone, setSearchTermone] = useState("");
  const [selectedcity, setSelectedcity] = useState(userData?.city || "");
  const [searchTermtwo, setSearchTermtwo] = useState("");
  const [hidefield, setHidefield] = useState(1);
  const [hidestate, setHidestate] = useState(1);
  const [hidecity, setHidecity] = useState(1);
  const { data: worldCitiesData } = useGetWorldCitiesQuery();
  const countrydata = worldCitiesData || [];
  const [getcountry] = useState();
  const [selectedState] = useState();
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);
  const [statetwo, setStatetwo] = useState(getcountry);
  const [city, setCity] = useState(selectedState);

  const [currency, setCurrency] = useState();

  const [salePromotion, setSalePromotion] = useState("");
  const [specialOffer, setSpecialOffer] = useState("");

  // Refs for input fields
  const itemnameRef = useRef(null);
  const priceRef = useRef(null);
  const quantityRef = useRef(null);
  const unitPriceRef = useRef(null);
  const minOrderQuantityRef = useRef(null);
  const descriptionRef = useRef(null);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleCountryChange = (event) => {
    const { value } = event.target;
    setSelectedCountry(value);
  };

  const handleSearchChangestate = (event) => {
    setSearchTermone(event.target.value);
  };

  const handleSearchChangecity = (event) => {
    setSearchTermtwo(event.target.value);
  };

  const handleCountryChangestate = (event) => {
    const { value } = event.target;
    setSelectedstateone(value);
  };

  const handleCountryChangecity = (event) => {
    const { value } = event.target;
    setSelectedcity(value);
  };

  const inputChange = (event) => {
    setUserData((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    // Clear input fields on mount to prevent autofill
    if (itemnameRef.current)
      itemnameRef.current.value = userData?.itemname || "";
    if (priceRef.current) priceRef.current.value = userData?.price || "";
    if (quantityRef.current)
      quantityRef.current.value = userData?.quantity || "";
    if (unitPriceRef.current)
      unitPriceRef.current.value = userData?.unitPrice || "";
    if (minOrderQuantityRef.current)
      minOrderQuantityRef.current.value = userData?.minOrderQuantity || "";
    if (descriptionRef.current)
      descriptionRef.current.value = userData?.description || "";
  }, [userData]);

  const country = [...new Set(countrydata.map((item) => item.country))].filter(
    Boolean,
  );
  country.sort();

  // Sync location from backend API userData
  useEffect(() => {
    const targetCountry = userData?.country || "";
    const targetState = userData?.state || "";
    const targetCity = userData?.city || "";

    if (targetCountry && targetCountry !== selectedCountry) {
      setSelectedCountry(targetCountry);
    }
    if (targetState && targetState !== selectedstateone) {
      setSelectedstateone(targetState);
    }
    if (targetCity && targetCity !== selectedcity) {
      setSelectedcity(targetCity);
    }
  }, [userData?.country, userData?.state, userData?.city]);

  // Synchronize state options whenever selectedCountry or countrydata changes
  useEffect(() => {
    if (selectedCountry && countrydata.length > 0) {
      let states = countrydata.filter(
        (item) => item.country === selectedCountry,
      );
      states = [...new Set(states.map((item) => item.subcountry))].filter(
        Boolean,
      );
      states.sort();
      setState(states);
    } else if (!selectedCountry) {
      setState([]);
    }
  }, [selectedCountry, countrydata]);

  // Synchronize city options whenever selectedstateone or countrydata changes
  useEffect(() => {
    if (selectedstateone && countrydata.length > 0) {
      let cities = countrydata.filter(
        (item) => item.subcountry === selectedstateone,
      );
      setGetcity(cities);
    } else if (!selectedstateone) {
      setGetcity([]);
    }
  }, [selectedstateone, countrydata]);

  const handleCountry = (e) => {
    let states = countrydata.filter(
      (state) => state.country === e.target.value,
    );
    states = [...new Set(states.map((item) => item.subcountry))];
    states.sort();
    setState(states);
  };

  const handleState = (e) => {
    let cities = countrydata.filter(
      (city) => city.subcountry === e.target.value,
    );
    setGetcity(cities);
  };

  const navigate = useNavigate();

  const validationSchema = Yup.object({
    itemname: Yup.string().required("itemname is required*"),
    country: Yup.string().required("Country is required*"),
    state: Yup.string().required("State is required*"),
    city: Yup.string().required("City is required*"),
    price: Yup.string().required("price is required*"),
    category: Yup.string().required("category is required*"),
    subCategory: Yup.string().required("subcategory is required"),
    quantity: Yup.string().required("totalquantity is required"),
    description: Yup.string().required("description is required"),
  });

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={{
          itemname: userData?.itemname || "",
          country: selectedCountry || userData?.country || "",
          state: selectedstateone || userData?.state || "",
          city: selectedcity || userData?.city || "",
          price: userData?.price || "",
          category: userData?.category || "",
          subCategory: userData?.subCategory || "",
          quantity: userData?.quantity || "",
          unitPrice: userData?.unitPrice || "",
          minOrderQuantity: userData?.minOrderQuantity || "",
          unitOfMeasurement: userData?.unitOfMeasurement || "",
          currency: userData?.currency || "",
          description: userData?.description || "",
          salespromotion: userData?.salespromotion || "",
          specialoffer: userData?.specialoffer || "",
        }}
        validateOnBlur={false}
        validationSchema={validationSchema}
        onSubmit={(values) => {}}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
          isValid,
          dirty,
        }) => (
          <Form
            autoComplete="off" // Disable autofill for the form
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            {/* Hidden input to trick autofill */}
            <input type="text" style={{ display: "none" }} autoComplete="off" />
            <Row>
              <div className="screenHeight d-flex justify-content-center align-items-center">
                <Col lg={9} md={11} className="Form-Shadow pb-3">
                  <div className="arrowback ps-3">
                    {location.pathname === `${updateurl}${index}` ? (
                      <BackArrow
                        back={`${backurl}/${userData?.shopid}/${index}`}
                        black="black"
                        mystyle="p-1 ps-4"
                      />
                    ) : (
                      <BackArrow
                        back={back + id}
                        black="black"
                        mystyle="ps-4 p-1"
                      />
                    )}
                  </div>
                  <Row className="pt-3 ps-5 pe-5">
                    <Col className="" md={3} lg={3}>
                      <Form.Label className="custm-lble">Item Name</Form.Label>
                      <Form.Control
                        placeholder="Item Name"
                        type="text"
                        name="itemname" // Non-standard name
                        className="labelText form-control-seller"
                        onChange={(e) => {
                          handleChange(e);
                          inputChange(e);
                        }}
                        onBlur={handleBlur}
                        defaultValue={userData?.itemname}
                        autoComplete="off"
                        ref={itemnameRef}
                        onFocus={(e) => {
                          if (!userData?.itemname) e.target.value = "";
                        }}
                      />
                      {errors.itemname && touched.itemname ? (
                        <div>
                          <p className="error_text_color">{errors.itemname}</p>
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} lg={3}>
                      <Form.Label className="custm-lble">Category</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="category" // Non-standard name
                        onChange={(e) => onCategoryFieldChange(e, handleChange)}
                        onBlur={handleBlur}
                        className="form-select-seller"
                        onClick={FirstCategory}
                        autoComplete="off"
                      >
                        {userData?.category?.length > 0 ? (
                          <option value="">{userData?.category}</option>
                        ) : (
                          <option value="">Select-Category</option>
                        )}
                        {shopCategory?.map((category) => (
                          <option
                            key={category._id}
                            value={categoryOptionValue(category)}
                          >
                            {category?.name}
                          </option>
                        ))}
                      </Form.Select>
                      {errors.category && touched.category ? (
                        <div>
                          <p className="error_text_color">{errors.category}</p>
                        </div>
                      ) : null}
                    </Col>
                    <Col className="" md={3} lg={3}>
                      <Form.Label className="custm-lble">
                        Sub Category
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="subCategory" // Non-standard name
                        className="form-select-seller"
                        onChange={(e) => onCategoryFieldChange(e, handleChange)}
                        onClick={Mydata}
                        onFocus={Mydata}
                        onBlur={handleBlur}
                        autoComplete="off"
                      >
                        {userData?.subCategory?.length > 0 ? (
                          <option value="">{userData?.subCategory}</option>
                        ) : (
                          <option value="">Select Sub Category</option>
                        )}
                        {shopCategorytwo?.map((subcategory) => (
                          <option
                            key={subcategory._id}
                            value={categoryOptionValue(subcategory)}
                          >
                            {subcategory?.name}
                          </option>
                        ))}
                      </Form.Select>
                      {errors.subCategory && touched.subCategory ? (
                        <div>
                          <p className="error_text_color">
                            {errors.subCategory}
                          </p>
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} lg={3}>
                      <Form.Label className="custm-lble">Price</Form.Label>
                      <Form.Control
                        placeholder="Price"
                        type="number"
                        name="price" // Non-standard name
                        onChange={(e) => {
                          handleChange(e);
                          inputChange(e);
                        }}
                        className="labelText form-control-seller"
                        onBlur={handleBlur}
                        defaultValue={userData?.price}
                        autoComplete="off"
                        ref={priceRef}
                        onFocus={(e) => {
                          if (!userData?.price) e.target.value = "";
                        }}
                      />
                      {errors.price && touched.price ? (
                        <div>
                          <p className="error_text_color">{errors.price}</p>
                        </div>
                      ) : null}
                    </Col>
                  </Row>
                  <Row className="pt-3 ps-5 pe-5">
                    <Col className="" md={3} lg={3}>
                      <Form.Label className="custm-lble">
                        Total Quantity
                      </Form.Label>
                      <Form.Control
                        placeholder="Total Quantity"
                        type="number"
                        className="labelText form-control-seller"
                        onChange={(e) => {
                          handleChange(e);
                          inputChange(e);
                        }}
                        defaultValue={userData?.quantity}
                        name="quantity" // Non-standard name
                        onBlur={handleBlur}
                        autoComplete="off"
                        ref={quantityRef}
                        onFocus={(e) => {
                          if (!userData?.quantity) e.target.value = "";
                        }}
                      />
                      {errors.quantity && touched.quantity ? (
                        <div>
                          <p className="error_text_color">{errors.quantity}</p>
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} lg={3}>
                      <Form.Label className="custm-lble">Country*</Form.Label>
                      <Form.Select
                        aria-label="Select Country"
                        name="country"
                        className="form-select-seller"
                        value={selectedCountry || values.country || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedCountry(val);
                          setSelectedstateone("");
                          setSelectedcity("");
                          setUserData((prevState) => ({
                            ...prevState,
                            country: val,
                            state: "",
                            city: "",
                          }));
                          handleChange(e);
                          setFieldValue("country", val);
                          setFieldValue("state", "");
                          setFieldValue("city", "");
                        }}
                        onBlur={handleBlur}
                        autoComplete="off"
                      >
                        <option value="">Select-Country</option>
                        {country.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      {errors.country && touched.country ? (
                        <div>
                          <p className="error_text_color">{errors.country}</p>
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} lg={3}>
                      <Form.Label className="custm-lble">State*</Form.Label>
                      <Form.Select
                        aria-label="Select State"
                        name="state"
                        className="form-select-seller"
                        value={selectedstateone || values.state || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedstateone(val);
                          setSelectedcity("");
                          setUserData((prevState) => ({
                            ...prevState,
                            state: val,
                            city: "",
                          }));
                          handleChange(e);
                          setFieldValue("state", val);
                          setFieldValue("city", "");
                        }}
                        onBlur={handleBlur}
                        autoComplete="off"
                      >
                        <option value="">Select-State</option>
                        {getState.map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                      </Form.Select>
                      {errors.state && touched.state ? (
                        <div>
                          <p className="error_text_color">{errors.state}</p>
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} lg={3}>
                      <Form.Label className="custm-lble">City*</Form.Label>
                      <Form.Select
                        aria-label="Select City"
                        name="city"
                        className="form-select-seller"
                        value={selectedcity || values.city || ""}
                        onChange={(e) => {
                          const val = e.target.value;
                          setSelectedcity(val);
                          setUserData((prevState) => ({
                            ...prevState,
                            city: val,
                          }));
                          handleChange(e);
                          setFieldValue("city", val);
                        }}
                        onBlur={handleBlur}
                        autoComplete="off"
                      >
                        <option value="">Select-City</option>
                        {getcity.map((item) => (
                          <option key={item.name} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Select>
                      {errors.city && touched.city ? (
                        <div>
                          <p className="error_text_color">{errors.city}</p>
                        </div>
                      ) : null}
                    </Col>
                    <Col className="mt-3" md={3} lg={3} xl={3}>
                      <Form.Label className="custm-lble">
                        Unit of Measurement
                      </Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="unitOfMeasurement" // Non-standard name
                        className="form-select-seller"
                        onChange={(e) => {
                          handleChange(e);
                          inputChange(e);
                        }}
                        onBlur={handleBlur}
                        autoComplete="off"
                      >
                        {userData?.unitOfMeasurement?.length > 0 ? (
                          <option>{userData?.unitOfMeasurement}</option>
                        ) : (
                          <option>Select Unit</option>
                        )}
                        {Measurementunit.map((e) => (
                          <option key={e.name}>{e.name}</option>
                        ))}
                      </Form.Select>
                      {errors.unitOfMeasurement && touched.unitOfMeasurement ? (
                        <div>
                          <p className="error_text_color">
                            {errors.unitOfMeasurement}
                          </p>
                        </div>
                      ) : null}
                    </Col>
                    <Col md={3} lg={3} xl={3} className="mt-3">
                      <Form.Label className="custm-lble">Currency</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        name="currency" // Non-standard name
                        className="form-select-seller"
                        onChange={(e) => {
                          handleChange(e);
                          inputChange(e);
                        }}
                        onBlur={handleBlur}
                        autoComplete="off"
                      >
                        {userData?.currency?.length > 0 ? (
                          <option>{userData?.currency}</option>
                        ) : (
                          <option>Select Currency</option>
                        )}
                        {currencies.map((e) => (
                          <option key={e.abbreviation}>
                            {e.abbreviation} {e.name}
                          </option>
                        ))}
                      </Form.Select>
                      {errors.currency && touched.currency ? (
                        <div>
                          <p className="error_text_color">{errors.currency}</p>
                        </div>
                      ) : null}
                    </Col>
                    {location.pathname === `/wholesaler-postadd/${id}` ||
                    location.pathname === `/manufacturer-postAdd/${id}` ||
                    location.pathname === `/rawmaterial-owner-profile/${id}` ? (
                      <>
                        <Col className="mt-3" md={3} lg={3}>
                          <Form.Label className="custm-lble">
                            Unit Price
                          </Form.Label>
                          <Form.Control
                            placeholder="Unit Price"
                            type="number"
                            name="unitPrice" // Non-standard name
                            className="labelText form-control-seller"
                            onChange={(e) => {
                              handleChange(e);
                              inputChange(e);
                            }}
                            onBlur={handleBlur}
                            defaultValue={userData?.unitPrice}
                            autoComplete="off"
                            ref={unitPriceRef}
                            onFocus={(e) => {
                              if (!userData?.unitPrice) e.target.value = "";
                            }}
                          />
                          {errors.unitPrice && touched.unitPrice ? (
                            <div>
                              <p className="error_text_color">
                                {errors.unitPrice}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                        <Col className="mt-3" md={3} lg={3}>
                          <Form.Label className="custm-lble">
                            Minimum Order Quantity
                          </Form.Label>
                          <Form.Control
                            placeholder="Minimum Order Quantity"
                            type="number"
                            name="minOrderQuantity" // Non-standard name
                            className="labelText form-control-seller"
                            onChange={(e) => {
                              handleChange(e);
                              inputChange(e);
                            }}
                            onBlur={handleBlur}
                            defaultValue={userData?.minOrderQuantity}
                            autoComplete="off"
                            ref={minOrderQuantityRef}
                            onFocus={(e) => {
                              if (!userData?.minOrderQuantity)
                                e.target.value = "";
                            }}
                          />
                          {errors.minOrderQuantity &&
                          touched.minOrderQuantity ? (
                            <div>
                              <p className="error_text_color">
                                {errors.minOrderQuantity}
                              </p>
                            </div>
                          ) : null}
                        </Col>
                      </>
                    ) : null}
                    {location.pathname === `/rawmaterial-postAdd/${id}` ||
                    location.pathname === `/manufacturer-postAdd/${id}` ||
                    location.pathname === `/wholesaler-postadd/${id}` ||
                    location.pathname === `/recycle-postadd/${id}` ? null : (
                      <>
                        <Col className="mt-3" md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">
                            Sale promotion (optional)
                          </Form.Label>

                          <Form.Select
                            aria-label="Sale promotion"
                            name="salespromotion"
                            className="form-select-seller"
                            value={salePromotion}
                            onChange={(e) => {
                              setSalePromotion(e.target.value);
                              handleChange(e);
                              inputChange(e);
                            }}
                            autoComplete="off"
                          >
                            {/* This option works as unselect / clear */}
                            <option value="">Un Select</option>

                            {salepromotion.map((e) => (
                              <option key={e.label} value={e.label}>
                                {e.label}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>

                        <Col className="mt-3" md={3} lg={3} xl={3}>
                          <Form.Label className="custm-lble">
                            Special offer (optional)
                          </Form.Label>

                          <Form.Select
                            aria-label="Special offer"
                            name="specialoffer"
                            className="form-select-seller"
                            value={specialOffer}
                            onChange={(e) => {
                              setSpecialOffer(e.target.value);
                              handleChange(e);
                              inputChange(e);
                            }}
                            autoComplete="off"
                          >
                            {/* Clear / Unselect option */}
                            <option value="">Un Select</option>

                            {saleoffer.map((e) => (
                              <option key={e.label} value={e.label}>
                                {e.label}
                              </option>
                            ))}
                          </Form.Select>
                        </Col>
                      </>
                    )}
                  </Row>
                  <div className="pt-3 pb-2 ps-5 pe-5">
                    <Form.Label className="custm-lble pb-1">
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={6}
                      name="description" // Non-standard name
                      placeholder="Description"
                      onChange={(e) => {
                        handleChange(e);
                        inputChange(e);
                      }}
                      defaultValue={userData?.description}
                      onBlur={handleBlur}
                      autoComplete="off"
                      ref={descriptionRef}
                      onFocus={(e) => {
                        if (!userData?.description) e.target.value = "";
                      }}
                    />
                    {errors.description && touched.description ? (
                      <div>
                        <p className="error_text_color">{errors.description}</p>
                      </div>
                    ) : null}
                  </div>
                  <Col lg="9" className="me-auto">
                    <Row>
                      <Col lg="9" className="me-auto">
                        <Row>
                          <Col lg={2} className="mt-2 ms-5">
                            <Card
                              style={{
                                width: "6rem",
                                height: "6rem",
                                position: "relative",
                              }}
                              {...getRootProps()}
                              className="dropzone"
                            >
                              {/* Show loader if uploading */}
                              {isUploading ? (
                                <div
                                  style={{
                                    position: "absolute",
                                    inset: 0,
                                    background: "rgba(255,255,255,0.7)",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    borderRadius: "0.5rem",
                                  }}
                                >
                                  <div
                                    className="spinner-border text-primary"
                                    style={{
                                      width: "1.5rem",
                                      height: "1.5rem",
                                    }}
                                    role="status"
                                  ></div>
                                  <small className="mt-1">
                                    {uploadProgress}%
                                  </small>
                                </div>
                              ) : (
                                <>
                                  <Card.Img
                                    className="imet-fit"
                                    src={images.AddImage}
                                  />
                                  <Card.Body>
                                    <input
                                      type="file"
                                      id="file"
                                      style={{ display: "none" }}
                                      {...getInputProps()}
                                      multiple
                                      autoComplete="off"
                                    />
                                  </Card.Body>
                                </>
                              )}
                            </Card>
                          </Col>

                          {displayimg?.length > 0 && (
                            <Col lg={7} className="mt-1 d-flex">
                              {displayimg.map((image, index) => (
                                <Card
                                  key={index}
                                  className="me-2 mt-1"
                                  style={{
                                    width: "6rem",
                                    height: "6rem",
                                    border: "2px solid",
                                    position: "relative",
                                  }}
                                >
                                  <Card.Img
                                    className="imet-fit upload-img mt-0"
                                    src={getAsset(image)}
                                    alt=""
                                    crossOrigin="anonymous"
                                  />
                                  <div
                                    className="close-btnone"
                                    onClick={() => removeImage(index)}
                                  >
                                    <ClearIcon />
                                  </div>
                                </Card>
                              ))}
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                  <div className="d-flex justify-content-end mt-2 mb-2 align-items-center">
                    <div>
                      <button
                        type="button"
                        className="btn-red-sm"
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="ms-3 me-4">
                      <button
                        type="submit"
                        className="btn-blue-sm disable-btn"
                        onClick={
                          butn === "Post" ? handlerFunction : Updatehandler
                        }
                        data-title={
                          location.pathname === `${updateurl}${index}`
                            ? null
                            : !(isValid && dirty)
                              ? "Please fill out all Fields to enable button!"
                              : null
                        }
                        disabled={
                          location.pathname === `${updateurl}${index}`
                            ? ""
                            : !(isValid && dirty)
                        }
                      >
                        {butn}
                      </button>
                    </div>
                  </div>
                </Col>
              </div>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PostAddForm;
